import { useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";
import type { FinancesNavigationState } from "web_myplann/Finances/Types/FinancesNavigationState";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import { MyPlannNavigationHeader } from "web_myplann/Shared/Header/MyPlannNavigationHeader";

type Props = {
	backRoute?: string;
	alwaysUseDefaultRoute?: boolean;
	backState?: FinancesNavigationState;
	onBack?: () => void;
	children: ReactNode;
};

export const FinancesWizardLayout: FC<Props> = ({
	backRoute,
	alwaysUseDefaultRoute = true,
	backState,
	onBack,
	children,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<MyPlannLayout
			disableContentPadding
			bgColor={theme.palette.surface.muted}
			topBar={
				<MyPlannNavigationHeader
					title={t(Resources.Finances.title)}
					defaultRoute={backRoute}
					alwaysUseDefaultRoute={alwaysUseDefaultRoute}
					replaceOnBack
					backState={backState}
					onBack={onBack}
					bgColor={theme.palette.background.appBar}
				/>
			}
		>
			{children}
		</MyPlannLayout>
	);
};
